import styled from 'styled-components';
import { media } from '../../../../constants/media/media';
import theme from '../../../../constants/theme';
import { Column, Columns } from '../../../base/grid';
import { Tab, Tabs } from '../../../base/tabs/tabs';
import { A } from '../../../base/typography';

export const Wrapper = styled.div``;

export const UnderneathBanner = styled.div`
	background-color: ${theme.colors.grayLight};
	display: flex;
	justify-content: space-between;
	padding: 1rem;
	p {
		padding-left: 2rem;
		margin: auto 0;

		${media.mobileOnly`
			display: none;
		`};
	}
	${media.mobileOnly`
		> button {
			margin-left: auto;
		}

		button {
			padding: 0 3rem 0 !important;
		}
	`};
	div {
		margin-left: auto;
		button {
			margin-left: 1rem;
		}
	}
`;

export const CtaLinks = styled.div`
	a {
		padding-right: 1rem;
		text-decoration: underline;
		color: ${theme.colors.gray};
		&:hover {
			color: ${theme.colors.black};
		}
	}
	button {
		margin-left: 1rem;
	}
	& > :last-child {
		padding-right: 0;
		button {
			margin-left: 0;
		}
	}
	& > button:last-child {
		padding-left: 5rem;
		padding-right: 5rem;
	}
`;

export const ContentTabs = styled(Tabs)`
	margin-bottom: 4rem;
`;

export const ContentTab = styled(Tab)`
	padding: 0rem;
	margin-right: 4rem;
`;

export const ShipmentCard = styled.div`
	position: relative;
	margin-top: 3rem;
	box-shadow: 0px 11px 24px #ececec;
	border: 1px solid #f1f1f1;

	a {
		margin-left: 1rem;
		text-decoration: underline;
	}

	div:last-child {
		border-right: 0;
	}

	${({ simple }) =>
		simple &&
		`
			padding: 4rem 3rem 3.5rem 3rem;
			text-align: center;
			border: 3px dashed #f1f1f1;

			svg {
			   margin: 0 1rem 0 0;
			}
		`};

	${({ delivered }) =>
		delivered &&
		`
			box-shadow: none;
			background-color: #f1f1f1;
			border-color: #e1e1e1;
			div {
				border-color: #e1e1e1;
				div { border-color: #e1e1e1 !IMPORTANT; }
			}
		`};
`;

export const CardHeadingWrapper = styled.div`
	display: flex;
	justify-content: space-between;
	padding: 2rem 3rem 1.5rem 3rem;
	color: ${theme.colors.black};
	border-bottom: 1px solid #f1f1f1;
	font-weight: 700;
`;

export const CardHeading = styled.p`
	display: block;
`;

export const CardMore = styled(A)`
	display: block;
	cursor: pointer;
	padding: 0;

	svg {
		max-height: 2.5rem;
		fill: ${theme.colors.grayLight};
	}

	${({ delivered }) =>
		delivered &&
		`
			svg {
				fill: ${theme.colors.gray};
			}
		`};

	${media.mobileOnly`
		display: none;
	`}
`;

export const ShipmentInfo = styled(Columns)`
	margin-left: inherit;
	margin-right: inherit;
	div {
		font-size: 1.6rem;
		display: inline-block;
		padding: 1.5rem 3rem;
		border-right: 1px solid #f1f1f1;
		margin-bottom: 0;
	}

	div:first-child {
		color: ${theme.colors.primary};
	}

	p {
		margin: 0 0 0.5rem 0;
	}

	${media.mobileOnly`

		div {
			display: block;
			border-right: 0;
			border-bottom: 1px solid ${theme.colors.grayLighter};
		}

		div:last-child {
			border-bottom: none;
		}

		div:first-child {
			border-bottom: 1px solid ${theme.colors.grayLighter};
			padding-bottom: 2rem;
		}

		div:first-child span {
			display: none;
		}
	`}
`;

export const MobileShowMore = styled.div`
	display: none;

	${media.mobileOnly`
		display: block;
		position: absolute;
		padding: 2rem 3rem 1.5rem 3rem;
		cursor: pointer;
		svg {
			max-height: 2.5rem;
			fill: ${theme.colors.grayLight};
		}
		text-align: right;
		top: 26rem;
		right: 1rem;
	`}
`;

export const ShipmentAdditionalInfo = styled.div`
	display: flex;
	align-items: stretch;
	border-top: 1px solid ${theme.colors.grayLighter};
`;

export const ShipmentsAdditionalInfoHeading = styled.div`
	color: ${theme.colors.black};
	font-weight: 700;
	font-size: 2.5rem;
	margin-bottom: 4rem;
`;

export const TrackingInfo = styled.div`
	flex: 0 0 55%;
	padding: 4rem 5rem;

	${media.mobileOnly`
		flex: 0 0 100%;
	`}
`;

export const MapContainer = styled.div`
	flex: 1;
	min-height: 40rem;

	${media.mobileOnly`
		display: none;
	`}
`;

export const Dot = styled.div`
	width: 1.7rem;
	height: 1.7rem;
	margin: 1.5rem 3rem;
	border-radius: 100%;
	background-color: ${theme.colors.secondary};
	border: 0.4rem solid white;
	justify-self: center;
	align-self: center;

	${({ active }) =>
		active &&
		`
		background-color: ${theme.colors.primary};
		position: relative;
		border: 0;

		&:before {
			background: none;
			border: 3px solid #fff;
			content: "";
			display: block;
			position: absolute;
			border-radius: 100%;
			top: 1px;
			left: 1px;
			right: 1px;
			bottom: 1px;
			pointer-events: none;
		}
	`}
`;

export const Line = styled.div`
	width: 1px;
	height: 7rem;
	margin: -1rem 0;
	justify-self: center;
	background-color: ${theme.colors.secondary};
`;

export const Timestamp = styled.div`
	div:first-child {
		font-size: 1.8rem;
		line-height: 1.7rem;
		color: ${theme.colors.black};
		font-weight: 700;
	}
`;

export const Description = styled.div`
	div:first-child {
		font-size: 1.8rem;
		line-height: 1.7rem;
		color: ${theme.colors.black};
		font-weight: 700;
	}
	font-size: 1.6rem;
`;

export const GridWrapper = styled.div`
	display: grid;
	grid-template-columns: auto auto auto;
	grid-template-rows: repeat;
	column-gap: 10px;
`;

export const ShipmentStatus = styled(Column)`
	display: flex !important;
	align-items: top;

	svg {
		display: block;
		margin-right: 1.5rem;
		height: 30px;
	}
	div {
		flex: 1;
		border: 0;
		padding: 0;
	}
`;

export const ShipmentNumber = styled(Column)`
	display: flex !important;
	align-items: top;

	div {
		flex: 1;
		border: 0;
		padding: 0;
	}

	svg {
		cursor: pointer;
		align-self: flex-start;
		vertical-align: middle;
	}
`;
